module.exports = __webpack_public_path__ + "static/media/hero-image-right-mobile.520fb922.png";